import { useQuery, UseQueryResult } from 'react-query';
import { BusinessService } from './types';
import { ErrorWithData } from './ErrorWithData';

interface GetProps {
  addOnId?: string;
}

async function get({ addOnId }: GetProps): Promise<BusinessService | undefined> {
  const apiUrl = window.BENCH.auApi.SETUP_BUSINESS_SERVICE_API_URL;
  if (!apiUrl)
    throw new Error('Missing required environment variables - SETUP_BUSINESS_SERVICE_API_URL');
  if (!addOnId) return;

  const response: Response = await fetch(`${apiUrl}/add-on/${addOnId}/business-service`, {
    method: 'GET',
    mode: 'cors',
    credentials: 'include',
  });

  if (!response.ok) {
    const error = (await response.json()) as Record<string, unknown>;
    throw new ErrorWithData('Failed to get business service', error);
  }
  return (await response.json()) as BusinessService | undefined;
}

interface CreateBusinessServiceProps {
  addOnId?: string;
}

export const useFetchBusinessService = ({
  addOnId,
}: CreateBusinessServiceProps): UseQueryResult<BusinessService | undefined> =>
  useQuery({
    queryKey: ['getBusinessService', { addOnId }],
    queryFn: () => get({ addOnId }),
    retry: false,
  });
